import React  from 'react';
import { permissionObj } from '../../../../../Helpers/permission';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import { CustomCardGrid } from '../../../../../components/CustomCardGrid';
import ButtonActionsCard from '../../../../../components/buttons/ButtonActionsCard';
import NotInformation from '../../../../../components/NotInformation';
import RowCardText from '../../../../../components/RowCardText';
import routes from '../../../../../Routes/routes';
import { colors } from '../../../../../enums/colors';
import {
    ArrowRightIcon,
    IconCheckboxChecked,
    IconCheckboxUnchecked
} from '../../../../../components/buttons/IconButtons';
import defaultImage from '../../../../../assets/IconsButtons/ic-ingredient-card.svg';
import renderAllergenIcons from './AllergenIcons';
import DishesCardsApp from "../Functionality/DishesCardsApp";
import {EMPTY_VALUES} from "../../../../../Apis/functions";
import DisplayView from "../../../../../components/DisplayView";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const DishesCards = ({
    view,
    setView,
    setBodyForExport,
    modified,
    setModified,
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    option
}) => {
    const {
        t,
        DEV,
        navigate,
        rowsPerPage,
        searchResults,
        setSearchResults,
        permission,
        elementRef,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        setSimpleSearch,
        handleDeleteAll,
        handleCheckboxChange,
        pagination
    } = DishesCardsApp({
        view,
        setBodyForExport,
        modified,
        setModified,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        option
    });

    return (
        <>
            <div className='d-flex'>
                <DisplayView view={view} setView={setView} className={''} />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={'txt_d_search_simple'}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        search={search}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        searchElement={searchElement}
                        contractorId={null}
                        supplierId={null}
                        viewType={VIEW_TYPE.GRID.viewType}
                    />
                </div>
            </div>

            {searchResults?.content?.length > 0 ? (
                <>
                    {DEV ||
                        (permission?.includes(permissionObj?.WEB_FOODIE_ITEM_DELETE) && (
                            <div className={''}>
                                <CustomCheckbox
                                    id={'cb_dc_all_checked'}
                                    trans={'de_/_select_all'}
                                    fontSize={'10px'}
                                    name={'isAllChecked'}
                                    checked={isAllChecked}
                                    onChange={(e) => {
                                        handleDeleteAll(e);
                                    }}
                                    icon={<IconCheckboxUnchecked className={"icon-color-general-950"}/>}
                                    checkedIcon={<IconCheckboxChecked className={"icon-color-shades-800"}/>}
                                    disableRipple={true}
                                />
                            </div>
                        ))}
                    <div className='panelTables' ref={elementRef}>
                        <div className='row'>
                            {searchResults?.content?.map((item, index) => (
                                <CustomCardGrid
                                    isCheckboxShow={DEV || permission?.includes(permissionObj?.WEB_FOODIE_ITEM_DELETE)}
                                    itemId={item?.id}
                                    checked={selectedList?.includes(item?.id)}
                                    onCheckboxChange={handleCheckboxChange}
                                    disabled={false}
                                    showCustomChip={false}
                                    isSquareImg={true}
                                    isDefaultIcon={true}
                                    statusColor={colors.secondary100}
                                    srcImage={item?.image ? `data:image/png;base64,${item?.image}` : defaultImage}
                                    btnActions={
                                        <>
                                            <ButtonActionsCard
                                                id={`btn_dc_actions_card_${index + 1}`}
                                                name={
                                                    (DEV || permission?.includes(permissionObj?.WEB_FOODIE_ITEM_UPDATE))
                                                        ? 'update'
                                                        : 'details'
                                                }
                                                Icon={ArrowRightIcon}
                                                onClick={() => {
                                                    navigate(`${routes.foodieDish.update}${item.id}`);
                                                }}
                                            />
                                        </>
                                    }
                                >
                                    <RowCardText title={t('name')} value={item.name || EMPTY_VALUES.DEFAULT} />
                                    <RowCardText title={t('item_code')} value={item.code || EMPTY_VALUES.DEFAULT} />
                                    <RowCardText title={t('contains')} />
                                    {renderAllergenIcons(item, t)}
                                </CustomCardGrid>
                            ))}
                        </div>
                    </div>
                    {pagination()}
                </>
            ) : (
                <NotInformation
                    card={true}
                    text={typeof searchResults?.content === 'undefined' ? t('loading') : t('you_have_not_created_any_meals_yet')}
                    showButton={DEV || permission?.includes(permissionObj?.WEB_FOODIE_ITEM_CREATE)}
                    buttonId={'btn_da_link_create'}
                    buttonUrl={routes.foodieDish.create}
                    buttonTrans={'create_new_meal'}
                    buttonOnclick={null}
                />
            )}
        </>
    );
};

export default DishesCards;
